import React from 'react';

interface CustomHintTextProps {
    hintText: string;
}


export const CustomHintText: React.FC<CustomHintTextProps> = ({ hintText }) => {
    return (
        <div className="form-group">
            <div className="driver-info">
                <span>{hintText}</span>
            </div>
        </div>
    );
};
